exports.f = {}.propertyIsEnumerable;



// WEBPACK FOOTER //
// ./node_modules/core-js/modules/_object-pie.js